var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropoff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#DD2736"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32857 7.37788C8.56288 7.14357 8.94278 7.14357 9.1771 7.37788L11.4291 9.62987C11.5416 9.74239 11.6048 9.895 11.6048 10.0541C11.6048 10.2133 11.5416 10.3659 11.4291 10.4784L9.1771 12.7304C8.94278 12.9647 8.56288 12.9647 8.32857 12.7304C8.09425 12.4961 8.09425 12.1162 8.32857 11.8819L10.1563 10.0541L8.32857 8.22641C8.09425 7.9921 8.09425 7.6122 8.32857 7.37788Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 10.0541C5 9.72273 5.26863 9.4541 5.6 9.4541H11.0048C11.3361 9.4541 11.6048 9.72273 11.6048 10.0541C11.6048 10.3855 11.3361 10.6541 11.0048 10.6541H5.6C5.26863 10.6541 5 10.3855 5 10.0541Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4979 5.40039C13.8293 5.40039 14.0979 5.66902 14.0979 6.00039V14.1075C14.0979 14.4389 13.8293 14.7075 13.4979 14.7075C13.1666 14.7075 12.8979 14.4389 12.8979 14.1075V6.00039C12.8979 5.66902 13.1666 5.40039 13.4979 5.40039Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropoff);
export default __webpack_public_path__ + "static/media/dropoff.82bd86e5d2581be60227b3c00ba1ce5c.svg";
export { ForwardRef as ReactComponent };